import type { ProjectFile, ProjectFileStreamKind } from '../types';

/** Version-track kinds external architects may see on Project Hub Files. */
export const ARCHITECT_HUB_FILE_STREAM_KINDS: readonly ProjectFileStreamKind[] = [
  'two_d_pdf',
  'three_d_html',
  'three_d_raw',
];

export function isArchitectHubVisibleStreamKind(
  kind: ProjectFileStreamKind | string | undefined,
): boolean {
  return kind === 'two_d_pdf' || kind === 'three_d_html' || kind === 'three_d_raw';
}

/** Folder files (no version track). Quotes and employee-only Financials stay hidden. */
export function isArchitectHubVisibleUnversionedFile(
  file: Pick<ProjectFile, 'streamId' | 'fileSection' | 'folderPath' | 'employeeOnly'>,
): boolean {
  if (file.fileSection === 'quote') return false;
  if (file.employeeOnly) return false;
  const folder = file.folderPath?.trim() ?? '';
  if (folder === 'financials' || folder.startsWith('financials/')) return false;
  return !file.streamId;
}
